import {
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import MainCard from "ui-component/cards/MainCard";
import { Form, Formik } from "formik";
import axios from "axios";
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import UploadVideo from "./UploadVideo";
import { dispatch } from "store";
import * as Yup from "yup";
import { openSnackbar } from "store/slices/snackbar";

const Add = ({ setIsDisplay }) => {
  const [videoCategoryList, setVideoCategoryList] = useState([]);
  const [subVideoCategoryList, setSubVideoCategoryList] = useState([]);

  const formikRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [uploading, setUploading] = useState(false);

  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const validationSchema = Yup.object({
    // categoryId: Yup.string().required("Category is required."),
    // subCategoryId: Yup.string().required("Sub Category is required"),
    path: Yup.string().required("Please upload a video."),
    title: Yup.string().required("Title is required.")
  });

  const initialValues = {
    path: "",
    // categoryId: "",
    title: "",
    // subCategoryId: ""
  };

  const handleSubmit = (values) => {
    setIsSubmitting(true);
    axios
      .post("/v1/alumni/video/add", values, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999) + rendomRequestId
          ),
        },
      })
      .then((response) => {
        dispatch(
          openSnackbar({
            open: true,
            message: response.data.Msg,
            variant: "alert",
            alert: {
              color: "success",
            },
            close: false,
          })
        );
        setIsSubmitting(false);
        generateTimeStamp();
        setIsDisplay("List");
      })
      .catch((error) => {
        setIsSubmitting(false);
        generateTimeStamp();
        dispatch(
          openSnackbar({
            open: true,
            message: error.response?.data?.Msg,
            variant: "alert",
            alert: {
              color: "error",
            },
            close: false,
          })
        );
      });
  };

  const fetchVideoCategory = async (categoryId) => {
    axios
      .get(
        `/v1/master/video-category?instituteId=${localStorage.getItem(
          "instituteId"
        )}&parentId=${categoryId}`,
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem(
              "serviceToken"
            )}`,
            "Content-Type": "application/json",
            requestId: RequestId(
              Math.floor(1000 + Math.random() * 9999),
              Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
            ),
          },
        }
      )
      .then((response) => {
        if (categoryId === 0) {
          setVideoCategoryList(response.data.data);
        } else {
          setSubVideoCategoryList(response?.data?.data);
        }
        generateTimeStamp();
      });
  };

  useEffect(() => {
    fetchVideoCategory(0);
    generateTimeStamp();
  }, []);

  return (
    <MainCard>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        innerRef={formikRef}
        validationSchema={validationSchema}
      >
        {({ values, handleChange, setFieldValue, touched, errors }) => (
          <Form>
            <Grid container spacing={2}>
              {/* Category Select */}
              {/* <Grid item md={6} xs={12}>
                <FormControl
                  fullWidth
                  error={touched.categoryId && Boolean(errors.categoryId)}
                >
                  <InputLabel id="category-label">Category</InputLabel>
                  <Select
                    labelId="category-label"
                    id="categoryId"
                    name="categoryId"
                    value={values.categoryId}
                    label="Category"
                    onChange={(e) => {
                      handleChange(e);
                      fetchVideoCategory(e.target.value);
                    }}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {videoCategoryList?.map((data) => (
                      <MenuItem key={data.id} value={data.id}>
                        {data.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched.categoryId && errors.categoryId && (
                    <FormHelperText>{errors.categoryId}</FormHelperText>
                  )}
                </FormControl>
              </Grid> */}

              <Grid item md={6} xs={12}>
                <TextField
                  fullWidth
                  type="text"
                  id="title"
                  label="Title"
                  name="title"
                  value={values?.title}
                  error={touched.title && Boolean(errors.title)}
                  helperText={touched.title && errors.title}
                  onChange={handleChange}
                />
              </Grid>

              {/* Subcategory Select */}
              {/* <Grid item md={6} xs={12}>
                <FormControl
                  fullWidth
                  error={touched.subCategoryId && Boolean(errors.subCategoryId)}
                >
                  <InputLabel id="subcategory-label">Sub Category</InputLabel>
                  <Select
                    labelId="subcategory-label"
                    id="subCategoryId"
                    name="subCategoryId"
                    value={values.subCategoryId}
                    onChange={handleChange}
                    label="Sub Category"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {subVideoCategoryList?.map((data) => (
                      <MenuItem key={data.id} value={data.id}>
                        {data.name}
                      </MenuItem>
                    ))}
                  </Select>
                  {touched.subCategoryId && errors.subCategoryId && (
                    <FormHelperText>{errors.subCategoryId}</FormHelperText>
                  )}
                </FormControl>
              </Grid> */}

              {/* Upload Video */}
              <Grid item md={12} xs={12}>
                <UploadVideo
                  setUploading={setUploading}
                  uploading={uploading}
                  setValue={setFieldValue}
                  onChange={handleChange}
                />
                {touched.path && errors.path && (
                  <FormHelperText error>{errors.path}</FormHelperText>
                )}
              </Grid>

              {/* Submit Button */}
              <Grid
                item
                md={12}
                xs={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  disabled={isSubmitting || uploading}
                  type="submit"
                  variant="contained"
                  color="primary"
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </MainCard>
  );
};

export default Add;
